import { gql } from "@apollo/client";
export const GET_CUSTOM_MAP_VALUES = gql `
  query GetMapStyleJSON($piKey: String!, $published: Boolean!) {
    mapStyleJSON(piKey: $piKey, published: $published)
  }
`;
export const GET_GEOJSONS = gql `
  query GetGeoJSONs(
    $campusKey: String!
    $piKey: String!
    $publicity: PublicityType!
  ) {
    geoJSONS(campusKey: $campusKey, piKey: $piKey, publicity: $publicity)
  }
`;
export const GET_DATA = gql `
  query getData($campusKeys: [String]!, $piKey: String!) {
    getData(campusKeys: $campusKeys, piKey: $piKey)
  }
`;
export const GET_GLOBAL_POI_STYLES = gql `
  query GetGlobalPoiStyles($piKey: String!, $languageCode: String!) {
    globalPoiStyles(piKey: $piKey, languageCode: $languageCode)
  }
`;
export const GET_BAD_OSM_IDS = gql `
  query getBadOsm($campusId: Int!) {
    campusHideOSMBuildings(campusId: $campusId)
  }
`;
